import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview } from '../lib/track';

export default function PageTracker() {
    const { pathname } = useLocation();

    useEffect(() => {
        trackPageview(pathname);
    }, [pathname]);

    return null;
}
